const STORAGE_KEY = 'mc_ads_params';
const TTL_MS = 90 * 24 * 60 * 60 * 1000;
const TRACKED_PARAMS = [
  'gclid', 'gbraid', 'wbraid',
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
];

const readStored = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed.savedAt || Date.now() - parsed.savedAt > TTL_MS) return null;
    return parsed.params || null;
  } catch {
    return null;
  }
};

// Guarda gclid/gbraid/wbraid/UTMs por 90 dias para atribuir conversões
// mesmo depois que a query string some na navegação interna do SPA.
export const captureAdsParams = (search) => {
  const query = new URLSearchParams(search);
  const found = {};
  TRACKED_PARAMS.forEach((key) => {
    const value = query.get(key);
    if (value) found[key] = value;
  });

  if (Object.keys(found).length === 0) return readStored() || {};

  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ savedAt: Date.now(), params: found })
    );
  } catch {
    // storage indisponível (modo privado): segue só com os da URL atual
  }
  return found;
};

export const getStoredAdsParams = () => readStored() || {};

// Replica o UtmData.js do site antigo: utm_source/utm_campaign da URL,
// senão referrer Google ("organic") ou Facebook ("facebook-organic"),
// senão o valor salvo (30 dias), senão "direct" (só para source).
const UTM_KEY = 'mc_utm';
const UTM_TTL_MS = 30 * 24 * 60 * 60 * 1000;
let utmCache = null;

export const getUtmData = (search = window.location.search, referrer = document.referrer) => {
  if (utmCache) return utmCache;

  const query = new URLSearchParams(search);
  const urlSource = query.get('utm_source');
  const urlCampaign = query.get('utm_campaign');
  const fromGoogle = (referrer || '').includes('google.com');
  const fromFacebook = (referrer || '').includes('facebook.com');

  let stored = {};
  try {
    const raw = JSON.parse(localStorage.getItem(UTM_KEY) || 'null');
    if (raw && Date.now() - raw.savedAt <= UTM_TTL_MS) stored = raw;
  } catch {
    stored = {};
  }
  if (fromGoogle || fromFacebook || urlSource || urlCampaign) stored = {};

  let source = urlSource;
  if (!source) {
    if (fromGoogle) source = 'organic';
    else if (fromFacebook) source = 'facebook-organic';
    else source = stored.source || null;
  }
  const campaign = urlCampaign || stored.campaign || null;

  try {
    if (source || campaign) {
      localStorage.setItem(UTM_KEY, JSON.stringify({ source, campaign, savedAt: Date.now() }));
    }
  } catch {
    // storage indisponível
  }

  utmCache = { source: source || 'direct', campaign };
  return utmCache;
};

// Remove o token de redefinição de senha (?code=) da URL enviada ao analytics
const sanitizeLocation = (href) => {
  const url = new URL(href);
  if (url.pathname === '/redefinir-senha') url.searchParams.delete('code');
  return url.toString();
};

export const pushPageView = ({ pathname, search }) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'page_view',
    page_path: `${pathname}${search}`,
    page_location: sanitizeLocation(window.location.href),
    page_title: document.title,
    ...getStoredAdsParams(),
  });
};
